import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../common/ModalTrigger';
import { putRequest } from '../../requestUtils';
import './WorkCompletedForProject.scss';
var WorkCompletedForProject = /*#__PURE__*/function (_Component) {
  function WorkCompletedForProject(props) {
    var _this;
    _classCallCheck(this, WorkCompletedForProject);
    _this = _callSuper(this, WorkCompletedForProject, [props]);
    _this.state = {
      createInvoice: null
    };
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }
  _inherits(WorkCompletedForProject, _Component);
  return _createClass(WorkCompletedForProject, [{
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        completeWorkUrl = _this$props.completeWorkUrl;
      var createInvoice = this.state.createInvoice;
      putRequest(completeWorkUrl, {
        create_invoice: createInvoice
      }, csrfToken).then(function () {
        window.location.reload();
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(bool) {
      this.setState({
        createInvoice: bool
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        style = _this$props2.style,
        triggerText = _this$props2.triggerText,
        triggerStyle = _this$props2.triggerStyle;
      var createInvoice = this.state.createInvoice;
      return /*#__PURE__*/React.createElement(ModalTrigger, {
        triggerText: triggerText,
        buttonStyles: "btn btn-sm ".concat(style, " ").concat(triggerStyle),
        submitButtonText: "Mark Work Completed",
        cancelButtonText: "Cancel",
        handleSubmit: this.handleSubmit,
        submitDisabled: createInvoice === null,
        triggerType: "link",
        idKey: "work-completed-for-project-modal"
      }, /*#__PURE__*/React.createElement("div", {
        className: "style-guide"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-3"
      }, "Is the consultant invoicing for the the current month?"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mb-3"
      }, "If the consultant is expected to invoice any hours, please start an invoice on their behalf for the current month before marking the project as completed."), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2"
      }, /*#__PURE__*/React.createElement("label", {
        className: "me-4 mb-2",
        htmlFor: "create"
      }, /*#__PURE__*/React.createElement("input", {
        type: "radio",
        id: "create",
        name: "create",
        checked: createInvoice === true,
        onChange: function onChange() {
          return _this2.handleChange(true);
        }
      }), "Yes, Create invoice for current month"), /*#__PURE__*/React.createElement("label", {
        htmlFor: "dont-create"
      }, /*#__PURE__*/React.createElement("input", {
        type: "radio",
        id: "dont-create",
        name: "dont-create",
        checked: createInvoice === false,
        onChange: function onChange() {
          return _this2.handleChange(false);
        }
      }), "No, Don't create invoice for the current month"))));
    }
  }]);
}(Component);
WorkCompletedForProject.propTypes = {
  triggerText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  triggerStyle: PropTypes.string,
  style: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  completeWorkUrl: PropTypes.string.isRequired
};
WorkCompletedForProject.defaultProps = {
  triggerText: 'Work Completed',
  triggerStyle: '',
  style: ''
};
export default WorkCompletedForProject;